<!----
    Author: hjlee
    Description:
        XDATA 입력 컨트롤
---->
<template>
  <div class="insert-row-control-area">
    <input style="display:none" type="text" name="faketextremembered" autofocus="true">
    <input style="display:none" type="password" name="fakepasswordremembered">
    <div class="rows">
      <div v-for="(insertColumn, index) in insertColumns" :key="index" :class="getCssClasses(insertColumn.inputControl)">
        <div v-if="(!step || step === insertColumn.inputControl.step) && insertColumn.inputControl && insertColumn.inputControl.type !== 'none' && (!onlyRequiredFields || insertColumn.inputControl.required)" class="form-group">
          <div class="controls">
            <input style="display:none" type="text" name="faketextremembered">
            <input style="display:none" type="password" name="fakepasswordremembered">
            <input-control
              :ref="'insertForm.' + insertColumn.key"
              v-model="userInsertRow[insertColumn.key]"
              :name="insertColumn.key.toSnakeCase()"
              :file-info="insertColumn.file"
              :options="getSelectOptions(insertColumn)"
              :title="insertColumn.label"
              :table-name="item"
              :purpose="purpose"
              :use-middle-name="insertColumn.inputControl.useMiddleName"
              :async-search-url="insertColumn.inputControl.asyncSearchUrl"
              :checkbox-label="insertColumn.inputControl.checkboxLabel"
              :fetching-children-url="insertColumn.inputControl.fetchingChildrenUrl"
              :get-initial-value-url="insertColumn.inputControl.getInitialValueUrl"
              :multiple="insertColumn.inputControl.multiple"
              :type="insertColumn.inputControl.type"
              :camera-button-image="cameraButtonImage"
              :show-image-viewer="showImageViewer"
              :cover-image="coverImage"
              :type-code-field-name="insertColumn.inputControl.typeCodeFieldName"
              :placeholder="insertColumn.inputControl.placeholderTextCode?$t(insertColumn.inputControl.placeholderTextCode):undefined"
              :orderable="insertColumn.inputControl.orderable"
              :rules="(dontCheckAuthor || hasAuthority('create_' + item))?getValidationRulesObject(insertColumn, module, item, userInsertRow):{}"
              :required="insertColumn.inputControl.required"
              :notifications="getNotifications(insertColumn.inputControl, true)"
              :prefix="getPrefix(insertColumn.inputControl, userInsertRow)"
              :postfix="getPostfix(insertColumn.inputControl, userInsertRow)"
              :visible-type="insertColumn.inputControl.visibleType"
              :visible-by="insertColumn.inputControl.visibleBy"
              :visible-data="userInsertRow"
              :disabled="authcodeStatus === 'verified' && insertColumn.key === 'userId'"
              :with-fields="getWithFields(insertColumn.inputControl)"
              @forceUpdate="onForceUpdate"
            />
            <div
              v-if="insertColumn.key === 'userId' && configs['user_id_validation_policy'] === 'before_registration' &&
                $refs && $refs['insertForm.userId'] &&
                ((!$refs['insertForm.userId']) || (!$refs['insertForm.userId'][0].errors) || (!$refs['insertForm.userId'][0].errors.count) || ($refs['insertForm.userId'][0].errors.count() === 0)) &&
                ((((configs['account_system'] === 'tel') || (configs['account_system'] === 'tel_or_email')) && isTelFormat(userInsertRow.userId)) ||
                (((configs['account_system'] === 'email') || (configs['account_system'] === 'tel_or_email')) && isEmailFormat(userInsertRow.userId)))"
            >
              <button v-if="authcodeStatus === 'init'" class="btn btn-default float-right" @click="sendAuthenticationCode()">
                {{ $t('auth.button.send_authcode') }}
              </button>
              <div v-else>
                <div class="input-group">
                  <input
                    v-model="userInsertRow.authcode"
                    :placeholder="$t('auth.placeholder.authcode')"
                    type="text"
                    class="form-control"
                    :disabled="!remainedMinutes || (authcodeStatus === 'verified')"
                    :status="authcodeStatus"
                  >
                  <div class="input-group-btn">
                    <button v-if="authcodeStatus !== 'verified'" class="btn btn-default" @click="resendAuthenticationCode()">
                      {{ $t('auth.button.resend_authcode') }} {{ remainedMinutes }}
                    </button>
                    <button class="btn btn-default" :disabled="!remainedMinutes || !userInsertRow.authcode || authcodeStatus === 'verified'" @click="verifyAuthenticationCode()">
                      {{ $t('auth.button.verify') }}
                    </button>
                  </div>
                </div>
                <pig-tail-label v-if="authcodeStatus !== 'verified' && isTelFormat(userInsertRow.userId)" :message="$t('auth.notification.tel.authcode')" />
                <pig-tail-label v-else-if="authcodeStatus !== 'verified' && isEmailFormat(userInsertRow.userId)" :message="$t('auth.notification.email.authcode')" />
                <pig-tail-label v-else-if="authcodeStatus === 'verified'" :message="$t('auth.result.user_verified')" />
              </div>
            </div>

            <input-control
              v-if="insertColumn.inputControl.type === 'password'"
              :ref="'insertForm.' + insertColumn.key + 'Confirm'"
              v-model="userInsertRow[insertColumn.key + 'Confirm']"
              name="user_pwd_confirm"
              :type="insertColumn.inputControl.type"
              :type-code-field-name="insertColumn.inputControl.typeCodeFieldName"
              :placeholder="insertColumn.inputControl.placeholderTextCode?$t(insertColumn.inputControl.placeholderTextCode):undefined"
              :orderable="insertColumn.inputControl.orderable"
              :rules="'password_confirm:' + userInsertRow[insertColumn.key]"
              :required="insertColumn.inputControl.required"
              :visible-type="insertColumn.inputControl.visibleType"
              :visible-by="insertColumn.inputControl.visibleBy"
              :visible-data="userInsertRow"
            />
          </div>
          <div v-if="insertColumn.clear" class="clear" />
        </div>
      </div>
      <div class="clear" />
      <additional-field-control
        v-if="infos && infos.additionalFieldInfoData"
        ref="insertForm.additionalFieldControl"
        v-model="userInsertRow"
        :table-name="item"
        :info-data="infos.additionalFieldInfoData"
        :only-required-fields="onlyRequiredFields"
        class="cols-xs-12 cols-sm-12 cols-md-12 cols-lg-12 cols-xl-12"
        @forceUpdate="onForceUpdate"
      />
      <div class="clear" />
    </div>
    <b-modal
      id="resend-authentication-code-confirm-modal"
      ref="resendAuthenticationCodeConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="sendAuthenticationCode"
    >
      <p class="my-4" v-html="$t('auth.warning.resend_authcode')" />
    </b-modal>
    <div v-if="showActionControls" class="form-actions">
      <button v-if="nextStep" class="btn btn-primary" :disabled="!contentsValidated('insertForm')" @click="next">
        {{ nextButtonName?nextButtonName:$t('common.button.next') }}
      </button>
      <button v-else class="btn btn-primary" type="submit" :disabled="!contentsValidated('insertForm')" @click="insert">
        {{ saveButtonName?saveButtonName:$t('common.button.insert') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cameraButtonImage: {
      type: String,
      default: undefined
    },
    showImageViewer: {
      type: Boolean,
      default: true
    },
    coverImage: {
      type: Boolean,
      default: true
    },
    loadCreateUrl: {
      type: String,
      required: true
    },
    showActionControls: {
      type: Boolean,
      default: true
    },
    createUrl: {
      type: String,
      required: true
    },
    sendAuthenticationUrl: {
      type: String,
      default: ''
    },
    verifyAuthenticationUrl: {
      type: String,
      default: ''
    },
    purpose: {
      type: String,
      default: 'general'
    },
    module: {
      type: String,
      required: true
    },
    item: {
      type: String,
      required: true
    },
    onlyRequiredFields: {
      type: Boolean,
      default: false
    },
    dontCheckAuthor: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: undefined
    },
    step: {
      type: String,
      default: ''
    },
    nextStep: {
      type: String,
      default: ''
    },
    saveButtonName: {
      type: String,
      default: ''
    },
    nextButtonName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      infos: {},
      userInsertRow: {},
      insertColumns: [],
      remainedMinutes: '',
      authcodeStatus: 'init',
      authcodeSentAddress: '',
      authcodeSentDt: undefined,
      authcodeExpirationMilliSecs: undefined,
      authcodeExpirationTimerId: undefined
    }
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.userInsertRow = newVal
        }
      },
      immediate: true,
      deep: true
    },
    userInsertRow: {
      handler(newVal, oldVal) {
        if (newVal && oldVal && newVal.userId !== this.authcodeSentAddress) {
          this.authcodeStatus = 'init'
          this.userInsertRow.authcode = ''
        }
        this.$emit('input', newVal)
        this.$emit('change', newVal)
      },
      deep: true
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    resendAuthenticationCode() {
      this.showModal('resendAuthenticationCodeConfirmModalRef')
    },
    sendAuthenticationCode() {
      const userId = this.userInsertRow.userId
      this.$axios
        .$post(this.sendAuthenticationUrl, { userId: userId })
        .then(response => {
          if (response.resultCode === 'success') {
            this.$toast.info(this.$t(response.message, response.params))
            this.authcodeStatus = 'sent'
            this.authcodeSentAddress = userId
            this.authcodeSentDt = new Date()
            this.authcodeExpirationMilliSecs = response.data
            if (this.authcodeExpirationTimerId) {
              clearTimeout(this.authcodeExpirationTimerId)
              this.authcodeExpirationTimerId = undefined
            }
            this.authcodeExpirationTimerId = setTimeout(
              this.refreshAuthcodeTimer,
              500
            )
          } else {
            this.authcodeStatus = 'sent'
            this.authcodeSentAddress = userId
            this.authcodeSentDt = new Date()
            this.authcodeExpirationMilliSecs = response.data
            this.authcodeExpirationTimerId = undefined
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
    },
    verifyAuthenticationCode() {
      const userId = this.userInsertRow.userId
      this.$axios
        .$post(this.verifyAuthenticationUrl, {
          userId: userId,
          authcode: this.userInsertRow.authcode
        })
        .then(response => {
          if (response.resultCode === 'success') {
            this.$toast.info(this.$t(response.message, response.params))
            this.authcodeStatus = 'verified'
          } else if (response.resultCode === 'already_verified_code') {
            this.$toast.success(this.$t(response.message, response.params))
          } else {
            this.userInsertRow.authcode = ''
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
        .catch(() => {
          this.userInsertRow.authcode = ''
        })
    },
    refreshAuthcodeTimer() {
      this.authcodeExpirationTimerId = undefined
      const now = new Date()
      const diff = now.getTime() - this.authcodeSentDt.getTime()
      let diffSec = (this.authcodeExpirationMilliSecs - diff) / 1000
      if (diffSec < 0) {
        diffSec = 0
        this.remainedMinutes = ''
      } else {
        this.remainedMinutes = Math.floor(diffSec / 60) + ':'
        const remainedSec = Math.floor(diffSec % 60)
        if (remainedSec < 10) {
          this.remainedMinutes += '0'
        }
        this.remainedMinutes += remainedSec
        this.authcodeExpirationTimerId = setTimeout(
          this.refreshAuthcodeTimer,
          500
        )
      }
    },
    isTelFormat(value) {
      if (!value) {
        return false
      }
      return window.isTelFormat(value)
    },
    isEmailFormat(value) {
      if (!value) {
        return false
      }
      return window.isEmailFormat(value)
    },
    next() {
      const param = {
        event: this.nextStep,
        row: this.userInsertRow
      }
      this.$emit('next-step', param)
    },
    insert() {
      const userInsertRow = window.copyObject(this.userInsertRow)
      // 사전 처리
      for (let i = this.insertColumns.length - 1; i >= 0; i--) {
        if (this.insertColumns[i].inputControl.type === 'multiselect') {
          const key = this.insertColumns[i].key
          const values = []
          if (userInsertRow[key] && userInsertRow[key].length > 0) {
            for (let j = 0; j < userInsertRow[key].length; j++) {
              values.push(userInsertRow[key][j].value)
            }
          }
          userInsertRow[key] = values
        }
      }
      let createUrl
      if (this.createUrl) {
        createUrl = this.createUrl
      } else {
        createUrl = this.module + '/manage/create/' + this.item.toCamelCase()
      }

      if (createUrl.indexOf('?') >= 0) {
        createUrl += '&'
      } else {
        createUrl += '?'
      }
      createUrl += this.getMenuAliasQuery()

      if (window.getCookie('agreedStipulations')) {
        userInsertRow.agreedStipulations = window.getCookie(
          'agreedStipulations'
        )
      }
      if (window.getCookie('disagreedStipulations')) {
        userInsertRow.disagreedStipulations = window.getCookie(
          'disagreedStipulations'
        )
      }
      this.$axios
        .$post(createUrl, userInsertRow)
        .then(response => {
          if (response.resultCode === 'success') {
            this.$toast.info(this.$t(response.message, response.params))
            const data = response.data
            if (data && data.charsts) {
              for (let i = 0; i < data.charsts.length; i++) {
                let locale = data.charsts[i].locale
                if (locale && locale.locale) {
                  locale = locale.locale
                }
                this.setI18nMessage(
                  locale,
                  data.charsts[i].code,
                  data.charsts[i].charst
                )
              }
            }
            this.$emit('inserted', userInsertRow)
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
        .catch(() => {
          this.isBusy = false
        })
    },
    load: function() {
      this.$axios.$get(this.loadCreateUrl).then(response => {
        if (response.resultCode === 'success') {
          this.lastResponse = response
          this.draw()
          if (this.value) {
            this.userInsertRow = this.value
          } else {
            this.userInsertRow = this.initInsertRow(this.insertColumns)
          }
          this.makeLabels(this.insertColumns)
        } else {
          console.error(this.$t(response.message, response.params))
          this.$toast.error(this.$t(response.message, response.params))
        }
      })
    },
    forceUpdate() {
      this.$forceUpdate()
    },
    draw: function() {
      if (!this.lastResponse) return
      const response = window.copyObject(this.lastResponse)
      if (this.value) {
        this.userInsertRow = this.value
      } else if (response && response.data && response.data.defaultData) {
        this.userInsertRow = response.data.defaultData
      }
      this.totalColumns = response.data.columns

      this.insertColumns = window.copyObject(this.totalColumns)

      this.infos = response.data.infos
      if (this.infos) {
        this.notifications = this.infos.notifications
      }
      if (!this.notifications) {
        this.notifications = []
      }
      if (this.infos && this.infos.insertNotifications) {
        this.notifications = this.notifications.concat(
          this.infos.insertNotifications
        )
      }
      if (this.insertColumns.length > 0) {
        for (let i = this.insertColumns.length - 1; i >= 0; i--) {
          if (!this.insertColumns[i].insert) {
            this.insertColumns.splice(i, 1)
            continue
          }
        }
      }
    }
  }
}
</script>
